import { render, staticRenderFns } from "./GoogleAd.vue?vue&type=template&id=9ec7ca1c&"
import script from "./GoogleAd.vue?vue&type=script&lang=js&"
export * from "./GoogleAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports